
import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { GetHelpText, getMyOwnOrders } from "../MyOwnOrders/api";
import { ModalForm } from "components/ModalForm/ModalForm";
import { CustomerSalesOrder } from "../ECommerce/components/Cart/components/CustomerSalesOrder";
import { MessageType } from "types/enum";
import { useLocation } from "react-router-dom";
interface MyOwnOrdersListProp{
    curentTab?:string;
    Type?:any;
    tabName?:string;
  }

export const MyOwnOrdersList = ({curentTab, Type ,tabName}:MyOwnOrdersListProp) => {

    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<any>([]);
    const [selectedObj, setSelectedObj] = useState< any>(null);
    const [showForm, setShowForm] = useState(false);
    const [mode, setMode] = useState("");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [jobstatusFilter, setJobstatusFilter] = useState<any>(0);
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [filterlist, setFilterlist] = useState<any>("");
    const [showAttachment, setShowAttachment] = useState(false);
    const [pages, setPages] = useState<number>(0);
    
    const [helpMessage,setHelpMessage]=useState<any>(null)
     const location=useLocation()
 



    const searchHandler = (str) => {
        setPageNum(1);
        if (str == "") {
            setSearch(null)
            getMyOwnOrdersAsync(1, null)
        } else {
            setSearch(str)
            getMyOwnOrdersAsync(1 , str)
        }
    }
    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("MyOwnOrdersList", e.currentTarget.value)
        getMyOwnOrdersAsync(1)
    };
    const handleGoPage = (value) => {
        if (value) {
            if (value < 1 || value > pages) { }
            else {setPageNum(+value);getMyOwnOrdersAsync(+value)}
        } 
    };
    const handleNextPage = () => {
        if(pageNum < pages){
            setPageNum(pageNum + 1);
            getMyOwnOrdersAsync(pageNum + 1);
        };
    };
    const handlePrevPage = () => {
        if(pageNum > 1){
            setPageNum((pageNum)=>{return +pageNum - 1});
            getMyOwnOrdersAsync(pageNum - 1);
        };
    };

    const selectedObjCallback = (obj) => {
        setSelectedObj(obj);
    }


    const handleCreate = () => {
        setMode("create")
        setShowForm(true)

    }
    const handleViewRow = () => {
        setMode("view");
        setShowForm(true)
    }
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel": downloadCSV(response ,4 ,trans("MyOwnOrdersList")); break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "view": if (selectedObj) handleViewRow(); break;
            case "help": alert("call api help"); break;
            case "create": handleCreate(); break;
            case "attach": if (selectedObj) {
                setMode("edit")
                setShowAttachment(true)
            } else {
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning)

            } break;
        }
    };


       async function getHelpTextAsync() {
     

        try {
            const res = await GetHelpText('myownorders')
         setHelpMessage(res.Data)
         
        } catch (error) {

        }
       

    }

    async function getMyOwnOrdersAsync(pagNum = pageNum ,searchSTR=search) {
        setLoading(false)

        let pageSizeChangedByUser = getPageSize("MyOwnOrdersList")
        setPageSize(pageSizeChangedByUser)
        try {
            const res = await getMyOwnOrders(pagNum, pageSizeChangedByUser, searchSTR, orderBy.length == 0 ? null : orderBy.join(","), filterlist, Type)
            setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
            if (res.Data.Data.length > 0) {
                setResponse(res.Data)
            }
        } catch (error) {

        }
        setLoading(true)

    }

    useEffect(() => {
        //getDataAsync();setResponse
          if(tabName==curentTab){

              setSelectedObj(null)
              setResponse([])
              getMyOwnOrdersAsync();
            }
    }, [ jobstatusFilter, orderBy, filterlist]);
    useEffect(() => {
        //getDataAsync();setResponse
          if(tabName==curentTab){

              setResponse([])
              getMyOwnOrdersAsync();
            }
    }, [ forceUpdate]);

    useEffect(() => {
        if(tabName==curentTab){
            let settings = getGridSetting("MyOwnOrdersList")
            setOrderBy(settings[1])
            setFilterlist(settings[0])
        }
    }, [curentTab ,tabName]);
useEffect(()=>{
  getHelpTextAsync()
    
},[])

    return (
        <>
        {tabName==curentTab&&
        <>

            { showForm &&
              <ModalForm title={"orderForm"} onHide={() => setShowForm(false)} show={showForm}>
                <CustomerSalesOrder Id={selectedObj?.Id} basketData={undefined} useClient={true} mode={mode}  onHide={()=>{setShowForm(false) ; setForceUpdate(!forceUpdate) }}  />
              </ModalForm>
            }



        <Toolbar create={true} defultSerach={search} handleSearch={searchHandler}   id={selectedObj} emptyList={response?.TotalRecords == 0} search={true} handleClickToolbar={clickToolbarCallback} />
        <div style={{overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",}} className="col-lg-12 mt-0">
            {loading ?
                <>{
                    (response?.Data?.length > 0 ?
                        <div className="card">
                            <div className="card-body p-0">
                                <>
                                    <DataGrid
                                        DoubleClick={(obj) => { setSelectedObj(obj); clickToolbarCallback("view") }}
                                        View={true}
                                        ViewParametr={"NotSeen"}
                                        handlefiltering={(str) => { setFilterlist(str) }}
                                        filterStr={filterlist}
                                        orderFormat={setOrderBy}
                                        orderFormatList={orderBy}
                                        parentName={"MyOwnOrdersList"}
                                        theadData={Object.keys(response.Data[0])}
                                        tbodyData={response.Data}
                                        minCellWidth={80}
                                        rowSelected={selectedObj}
                                        // handleAttachment={(e) => { setSelectedObj({ Id: e }); setMode("edit"); setShowAttachment(true) }}
                                        selectedRowObjectCallback={selectedObjCallback}
                                        startIndex={2}
                                        handleView={handleViewRow}
                                        totalRecords={response.TotalRecords}
                                        pageNum={pageNum}
                                        pageSize={pageSize}
                                        HandleNextPage={handleNextPage}
                                        HandlePrevPage={handlePrevPage}
                                        handlechangePageSize={handleChangePageSize}
                                        first={() =>{getMyOwnOrdersAsync(pages) ;setPageNum(pages)}}
                                        end={() => {getMyOwnOrdersAsync(1) ;setPageNum(1)}}
                                        handleGoPage={handleGoPage}
                                    />
                                </>
                            </div>
                        </div>
                        : <Message message={"NoDataForPreview"} type={messageType} />
                    )

                }
                </>
                : <Loading />
            }
                                    { helpMessage ? <Message message={helpMessage} type={"instruction"} />:<></>}

        </div>

        </>
        }
        
        </>

    );
}